export default "__VITE_ASSET__6aa68b18__"